import { AxiosResponse } from 'axios';
import { wlTransactionList } from '@/api/wlTransaction';
import { AppError } from '@/errors/appError';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IListParams, IWlTransactionApiListResponse } from '@/types';

export const wlTransactionService = {
    async list(params: IListParams<Record<string, any>>): Promise<AxiosResponse<IWlTransactionApiListResponse>> {
        try {
            const response = await baseListService<IWlTransactionApiListResponse>(wlTransactionList, params);
            return response;
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('WL Transaction API Error:', e);
            throw new AppError(`Unable to load WL transaction list, request error`, { cause: e });
        } finally {
        }
    },
};
